import customAxios from "../../customHook/customAxios";

import { getAuthHeader } from '../../utils';

export const v4_expense_applications = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/expense/applications/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_change_expense_application_staus = async (model, expenseId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/expense/applications/${expenseId}`;
    return customAxios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}
